export {onPageTransitionEnd};

import {reportLoadingEnd} from '../components/LoadingContext.jsx';

// Pairs with +onPageTransitionStart.js; Vike guarantees this fires even for
// aborted navigations, so the loading bar can't get stuck on.
function onPageTransitionEnd() {
    reportLoadingEnd();
}
